import { PAGESITS } from '../consts/display';
import ah from './ajax-helper';
import i18n from 'i18next';

var log = require('loglevel').getLogger('utils/logger');

var t = i18n.getFixedT(null, 'app');
var initialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
var cfg = initialState.envCfg;
export default function (action, target) {
  var moduleName = getKey();
  return ah.post("".concat(cfg.contextRoot, "/audit-log/create"), JSON.stringify({
    moduleName: moduleName,
    actionName: t("logger.action-".concat(action)),
    target: target,
    actionResult: 0,
    severity: 1
  }), null, true).then(function (result) {
    if (result.code < 0) log.error(result.error);
    return result;
  }).catch(function (err) {
    log.error(error);
    return error;
  });
}

function getKey() {
  var _window = window,
      location = _window.location;
  if (!location) return null;

  var currentPage = _(PAGESITS).filter(function (val) {
    if (location.pathname.indexOf(val.url) >= 0) {
      return true;
    }

    return false;
  }).sortBy(function (el) {
    return 0 - el.url.length;
  }).take(1).value();

  if (currentPage && currentPage[0]) {
    var urlComps = _.filter(currentPage[0].url.split('/'), function (el) {
      return el;
    });

    var lngKey = '';

    if (urlComps.length > 1) {
      lngKey = urlComps.join('.');
    } else if (urlComps.length === 1) {
      lngKey = "".concat(urlComps[0], ".title");
    }

    lngKey = "menu.side.".concat(lngKey);

    if (i18n.exists(lngKey, {
      ns: 'app'
    })) {
      return t(lngKey);
    } else {
      return '';
    }
  }

  return null;
}